<template>
  <el-row>
    <el-form :model="businessMemberItemForm"
             ref="businessMemberItemRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="/businessIntranet/rechargeMemberTime.action"
             editAction="/businessIntranet/rechargeMemberTime.action"
             selectAction=""
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="会员账号：" prop="phone">
        <el-input v-model="businessMemberItemForm.phone" placeholder="请输入已注册的11位手机号" @blur="selectMemberInfo"></el-input>
      </el-form-item>
      <el-form-item label="用户信息" prop="userInfo">
        <el-input :disabled="true" v-model="businessMemberItemForm.userInfo" placeholder="输入账号后，自动显示用户姓名和商家名称"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" prop="memberRoleType">
        <el-select :disabled="true" v-model="businessMemberItemForm.memberRoleType">
          <el-option :value="1" label="普通用户"></el-option>
          <el-option :value="3" label="卖车通会员"></el-option>
          <el-option :value="5" label="买卖通会员"></el-option>
          <el-option :value="6" label="专享通会员"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="当前到期时间" prop="currentEndTime">
        <el-input :disabled="true" v-model="businessMemberItemForm.currentEndTime" placeholder="到期时间"></el-input>
      </el-form-item>
      <el-form-item label="会员类型：" prop="roleId">
        <el-select v-model="businessMemberItemForm.roleId" placeholder="请选择会员类型" :clearable="true"  @change="chooseMemberRoles()" :filterable="true">
          <el-option
                  v-for="item in memberRoles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会员到期：" prop="endTime">
        <el-date-picker
                v-model="businessMemberItemForm.endTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="付款金额：" prop="totalMoney">
        <el-input type="number" v-model="businessMemberItemForm.totalMoney" ></el-input>
      </el-form-item>
      <el-form-item label="赠送线索权益(次)：" prop="legalCount">
        <el-input type="number"  min="0" step="1"  v-model="businessMemberItemForm.legalCount" ></el-input>
      </el-form-item>
      <el-form-item label="赠送人脉权益(个)：" prop="contactsCount">
        <el-input type="number"  min="0" step="1"  v-model="businessMemberItemForm.contactsCount" ></el-input>
      </el-form-item>
      <el-form-item label="赠送车商群(个)：" prop="groupCount">
        <el-input type="number"  min="0" step="1"  v-model="businessMemberItemForm.groupCount" ></el-input>
      </el-form-item>

      <el-form-item label="赠送推广通(元)：" prop="spreadCanUsedMoney">
        <el-input type="number" v-model="businessMemberItemForm.spreadCanUsedMoney" ></el-input>
      </el-form-item>

      <el-form-item label="收款业务员：" prop="collectionClerk">
        <el-input type="text" v-model="businessMemberItemForm.collectionClerk" ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'businessMemberItem',
  extends: BasicPager,
  components: {},
  data: function () {
    var checkPrice = (rule, value, callback) => {
      if (value < 0 || value > 10000) {
        return callback(new Error('请填写0-10000元之间的整数（单位元）'))
      }
      callback()
    }

    var checkPriceSpread = (rule, value, callback) => {
      if (value < 0 || value > 2000) {
        return callback(new Error('请填写0-2000元之间的整数（单位元）'))
      }
      callback()
    }

    var checkLegalCount = (rule, value, callback) => {
      if (value < 0 || value > 10000) {
        return callback(new Error('请填写0-10000之间的整数（单位次数）'))
      }
      callback()
    }
    var checkContactsCount = (rule, value, callback) => {
      if (value < 0 || value > 10000) {
        return callback(new Error('请填写0-10000之间的整数（单位个数）'))
      }
      callback()
    }

    var checkGroupCount = (rule, value, callback) => {
      if (value < 0 || value > 10000) {
        return callback(new Error('请填写0-10000之间的整数（单位个数）'))
      }
      callback()
    }
    return {
      rules: {
        phone: [
          { required: true, message: '请输入注册账号', trigger: 'blur' }, { max: 11, message: '电话号码不能大于11位！' }
        ],
        userInfo: [
          { required: true, message: '请等待加载商家信息中', trigger: 'blur' }
        ],
        totalMoney: [{
          required: true,
          message: '请输入付款金额'
        }, {
          validator: checkPrice,
          trigger: 'blur'
        }],
        spreadCanUsedMoney: [{
          required: true,
          message: '请输入赠送推广通金额(元)'
        }, {
          validator: checkPriceSpread,
          trigger: 'blur'
        }],
        endTime: [
          { required: true, message: '请输入会员到期时间', trigger: 'blur' }
        ],
        legalCount: [{
          required: true,
          message: '请输入赠送线索权益(次)'
        },
        { validator: checkLegalCount,
          trigger: 'blur'
        }
        ],
        roleId: [{
          required: true,
          message: '会员类型不能为空'
        }
        ],
        contactsCount: [{
          required: true,
          message: '请输入赠送人脉权益(个)'
        },
        { validator: checkContactsCount,
          trigger: 'blur'
        }
        ],
        groupCount: [{
          required: true,
          message: '请输入赠送车商群(个)'
        },
        { validator: checkGroupCount,
          trigger: 'blur'
        }
        ]
      },
      businessMemberItemForm: {
        id: null,
        userInfo: null,
        memberRoleType: null,
        currentEndTime: null,
        totalMoney: null,
        type: 3,
        endTime: null,
        collectionClerk: null,
        contactsCount: null,
        legalCount: null,
        groupCount: null,
        roleId: null
      },
      memberRoles: []
    }
  },
  created () {
    this.businessMemberItemForm.id = this.$route.query.id
    this.findMemberRoles()
  },
  methods: {

    findMemberRoles () {
      let _this = this
      let params = {}
      let listener = {
        success: function (dataInfo) {
          _this.memberRoles = dataInfo.datas
        }

      }

      BasicModel.get(_this, '/businessIntranet/findMemberRoles.action', params, listener)
    },
    chooseMemberRoles () {
      let _this = this
      let params = { id: this.businessMemberItemForm.id, memberRoleId: this.businessMemberItemForm.roleId }
      let listener = {
        success: function (dataInfo) {
          _this.businessMemberItemForm.endTime = dataInfo.datas.endTime
        }

      }

      BasicModel.get(_this, '/businessIntranet/selectMemberRoles.action', params, listener)
    },
    selectMemberInfo: function (phone) {
      if (!this.businessMemberItemForm.phone) {
        return
      }

      let _this = this
      let params = { phone: this.businessMemberItemForm.phone }
      let listener = {
        success: function (dataInfo) {
          if (!dataInfo.success) {
            _this.$message({
              type: 'error',
              message: dataInfo.errMsg
            })
          } else {
            _this.businessMemberItemForm.userInfo = dataInfo.datas.businessName + '-' + dataInfo.datas.phone
            _this.businessMemberItemForm.endTime = dataInfo.datas.businessEndTime
            _this.businessMemberItemForm.currentEndTime = dataInfo.datas.currentEndTime
            _this.businessMemberItemForm.memberRoleType = dataInfo.datas.memberRoleType

            _this.businessMemberItemForm.id = dataInfo.datas.businessId
          }
        }

      }

      BasicModel.get(_this, '/businessIntranet/selectMemberInfo.action', params, listener)
    },
    onFilterParams: function (params) {
      params.totalMoney = parseInt(params.totalMoney * 100)
      params.spreadCanUsedMoney = parseInt(params.spreadCanUsedMoney * 100)
    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
